import { createSelector } from 'reselect'
import { immutableSelector } from 'utils/selectors'
import { Overview, Social, Details, Messaging, Theme } from './models'
import { constants } from './constants'

export const profile = state => state.getIn(['profileUI', 'data'])
export const handle = createSelector(
  state => state.getIn(['profileUI', 'data', 'handle']),
  handle => {
    if (typeof handle === 'undefined') {
      return ''
    }
    return handle
  }
)

export const orgHandle = state => state.getIn(['profileUI', 'data', 'orgHandle'])
export const globalHandle = state => state.getIn(['profileUI', 'data', 'globalHandle'])
export const handleFetchStatus = state => state.getIn(['profileUI', 'handle', 'status'])
export const globalHandleCheckComplete = state =>
  state.getIn(['profileUI', 'handle', 'status'], false) === constants.RECEIVE_USER_GLOBAL_HANDLE_EXISTENCE
export const isGlobalHandleValid = state => state.getIn(['profileUI', 'valid', 'globalHandle'], true)
export const isHandleValid = state => state.getIn(['profileUI', 'valid', 'handle'], true)

export const isValidHandle = createSelector(
  handle,
  state => state.getIn(['profile', 'data', 'handle']),
  state => state.getIn(['profileUI', 'valid', 'handle']),
  (handle, originalHandle, valid) => {
    if (handle === originalHandle || typeof valid === 'undefined') return true
    return valid && !!handle && handle.length > 0 && !handle.includes('.')
  }
)

export const overview = createSelector(
  [handle, globalHandle, immutableSelector(profile, profile => Overview(profile))],
  (handle, globalHandle, overview) => {
    return overview.set('handle', handle).set('globalHandle', globalHandle)
  }
)
export const social = immutableSelector(profile, profile => Social(profile))
export const details = immutableSelector(profile, profile => Details(profile))
export const messaging = immutableSelector(profile, profile => Messaging(profile))
export const theme = immutableSelector(profile, profile => Theme(profile))
export const coverPhotoUpload = state => state.getIn(['profileUI', 'coverPhotoUpload'])



// WEBPACK FOOTER //
// ./src/scripts/app/modules/profile/selectorsUI.js